import React, { useEffect } from "react";
import CartCard from "../Cart-Card/CartCard";
import { useDispatch, useSelector } from "react-redux";
import { getUserCart } from "../../appState/slices/cart/cartSlice";
import Empty from "../EmptyComponent/Empty";
const CartProdutLayout = () => {
    const cart = useSelector(state => state.cart.cart) || [];

    return (
        <div className="container-fluid">
            <div className="row cartleftmargin">
                {cart?.items?.length > 0 ? (
                    cart.items.map((item, index) => (
                        <div
                            key={item._id || index}
                            className="col-lg-6 col-md-6 col-sm-12 ps-0 pe-1 pb-1"
                        >
                            <CartCard product={item} />
                        </div>
                    ))
                ) : (
                    <Empty
                        icon="SmileySad"
                        title="Your Bag is empty"
                        subtitle="Add new products and be a part of Purecarats."
                    />
                )}
            </div>
        </div>

    )
};

export default CartProdutLayout;